import { CanActivateFn, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { inject } from '@angular/core';
import { AuthenticationService } from '../core/service/auth/authentication.service';

export const authGuard: CanActivateFn = (route, state) => {
  // return true;
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true;
  } else {
    // Store the attempted URL for redirecting after login
    authService.setRedirectUrl(state.url);
    return router.parseUrl('/login');
  }
};
